import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { teamActions, teamSelectors } from '../../../../store/modules/team';
import { userSelectors } from '../../../../store/modules/user';

export const useTeamFetcher = () => {
  const dispatch = useDispatch();
  const members = useSelector(teamSelectors.selectTeamMembers);
  const fetchTeamError = useSelector(teamSelectors.selectTeamFetchError);
  const userTeamId = useSelector(userSelectors.selectTeamId);
  const teamId = useSelector(teamSelectors.selectTeamId);
  const isFetchPending = useSelector(teamSelectors.selectTeamFetchPending);

  const fetchTeamInfo = useCallback(() => {
    if (isFetchPending || teamId || !userTeamId) return;
    dispatch(teamActions.fetchTeam());
  }, [isFetchPending, teamId, userTeamId]);

  return [{ members, isFetchPending, ...fetchTeamError }, { fetchTeamInfo }] as const;
};

const useTeamFetch = () => {
  const [{ members, isFetchPending }, { fetchTeamInfo }] = useTeamFetcher();
  const userTeamId = useSelector(userSelectors.selectTeamId);
  const teamId = useSelector(teamSelectors.selectTeamId);

  const [isPending, setPending] = useState(true);

  useEffect(() => {
    fetchTeamInfo();
  }, [userTeamId]);

  useEffect(() => {
    if (isFetchPending || !teamId || !userTeamId) return;
    setPending(false);
  }, [isFetchPending, teamId]);

  return { teamId, isPending, members };
};

export default useTeamFetch;
